import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";
import {EditPopup} from "./components/EditPopup";
import {REST_URL} from "../../component/const/Const";

export const UserDetail2 = () => {
    const location = useLocation();
    const {ids} = location.state;
    // const ids = [
    //     {"keyName": "회원_관리_번호", "id": 1},
    //     {"keyName": "활동_관리_번호", "id": 5}
    // ];

    const convertText = text => text.split('_').filter(it => it !== '번호').join(' ');

    const [tableId, setTableId] = useState(null)
    const [mockInfo, setMockInfo] = useState([]);

    const fetchData = async (tableName, id) => {
        try {
            if (tableName.includes('개별')) {
                const {data} = await axios.get(REST_URL + `/${tableName.replace(/_번호$/, "")}?${tableName}=eq.${id}`)
                const real = data[0]
                console.log(real)
                const {"시험_문제": arr, ...rest} = real
                console.log(arr)
                console.log(rest)
                return {'시험_개별_관리': rest, '시험_문제': arr}
            } else {
                const {data} = await axios.get(`${REST_URL}${tableName.replace(/_번호$/, "")}?${tableName}=eq.${id}`);
                console.log(data)
                return data[0];
            }
        } catch (err) {
            console.error("데이터 fetch 실패:", err);
            return 0;
        }
    };

    const init = async () => {
        const list = []
        for (let i = 0; i < ids.length; i++) {
            const data = await fetchData(ids[i]["keyName"], ids[i]["id"])
            if (data.hasOwnProperty('시험_문제')) {
                list.push(data['시험_개별_관리']);
                list.push(data['시험_문제']);
            } else {
                list.push(data)
            }
        }
        setMockInfo(list)
    }

    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        console.log(mockInfo)
    }, [mockInfo]);


    return (
        <main className="p-16">
            {tableId != null &&
                <EditPopup
                    id={ids[tableId]["id"]}
                    tableName={ids[tableId]["keyName"].replace(/_번호$/, "")}
                    close={() => setTableId(null)}/>
            }
            {ids.map((el, idx) => (<div key={el.id}>
                <div className={`flex items-center mb-8 gap-6`}>
                    <h1 className={`text-5xl font-extrabold`}>{convertText(el.keyName)}</h1>
                    <button
                        className={`py-4 px-8 bg-slate-800 font-bold text-center text-white text-2xl rounded-xl`}
                        onClick={async () => setTableId(idx)}>수정하기
                    </button>
                </div>
                <ul className={`flex    gap-y-8 justify-start  flex-wrap mb-8`}>
                    {mockInfo && Object.entries(mockInfo[idx] || {}).map(([key, item]) => (
                        <li key={key}
                            className="[&_input]:text-center [&_select]:text-center text-2xl  items-stretch">
                            <div
                                className={`bg-slate-800  text-white text-center py-3 text-2xl px-8 border-x border-white`}>
                                {key}
                            </div>
                            <div
                                className={`text-2xl text-center p-3 bg-slate-100 block border-x border-black`}>{String(mockInfo[idx][key]) || "null"
                            }</div>
                        </li>
                    ))}
                </ul>
            </div>))}
            {mockInfo.length > ids.length && mockInfo.map((row, index) => index >= ids.length && row &&
                <table className="p-16 w-full">
                    <thead className='[&_input]:text-center [&_select]:text-center text-2xl  items-stretch'>
                    <tr>{Object.keys(row[0]).map((item, index) =>
                        <th className='bg-slate-800  text-white text-center py-3 text-2xl px-8 border-x border-white'
                            key={`${item}${index}`}>{item}</th>)}</tr>
                    </thead>
                    <tbody>
                    {row.map((item, index) => <tr key={index}>
                        {Object.values(item).map((it, idx) => (
                            <td className='text-2xl text-center p-3 bg-slate-100 max-w-40 break-words border border-black'
                                key={`${item}${index}${idx}`}>{it}</td>))}
                    </tr>)}
                    </tbody>
                </table>
            )}
        </main>
    )
        ;
};
